import React, { useEffect, useState } from "react"; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import "swiper/css"
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay"; // optional, just for clarity
import { Navigation, Pagination, Autoplay } from "swiper/modules"; 
  const LatestBlog = ({ typ,id,home }) => {  
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

    useEffect(() => {
        fetch(`${API}/api/blogsapi.ashx`, {  
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ typ,id,home })
      })
        .then(res => res.json())
        .then(res => {
          if (res.result === 1) {          // <-- fixed here
            setListings(res.data);          // <-- set the array
          } else {
            console.error("Error:", res.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        });
    }, [typ,id,home]);
  
    if (loading) return <p>Loading latest blogs...</p>;
  
  return (
    <div className="wrap-categories-sw wow fadeInUp" data-wow-delay=".2s">
      <Swiper
        spaceBetween={30}
        slidesPerView={6}
        modules={[Navigation, Pagination,Autoplay]} 
        //navigation               // ✅ arrows
        pagination={{ clickable: true }}  // ✅ dots
         autoplay={{
          delay: 3000, // 3 seconds
          disableOnInteraction: false, // continue autoplay after user interaction
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 15 },
          640: { slidesPerView: 3, spaceBetween: 15 },
          768: { slidesPerView: 3, spaceBetween: 30 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        className="tf-sw-categories"
      >
       {listings.map(item => (
       <SwiperSlide>
    <Link
  to={`${item.url}`}
  className="flat-blog-item hover-img"
>
      <div className="img-style">
        <img
          className="lazyload"
          data-src={item.Image+'/w=421,sharpen=1'}
          src={item.Image+'/w=421,sharpen=1'}
          alt={item.title}
        />
      </div>
      <div className="content-box">
        <h5 className="title link">
         {item.title}
        </h5>
        <p className="description">
          <span id="ctl00_ContentPlaceHolder1_lstblog_ctrl0_lbldescription">
            {item.shortdescription}
          </span>
        </p>
      </div>
    </Link>
    <div className="content-bottom" style={{ marginBottom: 30 }}>
  <Link style={{ width: "100%" }} to={`${item.url}`}>
  <h6 className="price">Read More</h6>
  </Link>
</div>
  </SwiperSlide>
    ))}
        {/* Add other SwiperSlide components here */}
      </Swiper>
    </div>
  );
}

export default LatestBlog;
